import { generateKeys } from '../utils';
export const backgroundJobs = {
    processPayment: 'PROCESS_PAYMENT',
    processRecurlyPayment: 'PROCESS_PAYMENT_RECURLY',
    forexDormantFee: 'PROCESS_DORMANT_FOREX',
    spotOptionDormantFee: 'PROCESS_DORMANT_SPOTOPTION',
    tradeSmarterDormantFee: 'PROCESS_DORMANT_TRADESMARTER',
    cuboidDormantFee: 'PROCESS_DORMANT_CUBOID',
    elasticSearchIndex: 'ELASTIC_SEARCH_INDEX',
    leadAssignment: 'LEAD_ASSIGNMENT',
    leadReassignment: 'LEAD_REASSIGNMENT',
    reassignAgentClients: 'REASSIGN_AGENT_CLIENTS',
    sendDocumentForVerification: 'SEND_DOC_FOR_VERIFICATION',
    scheduledNotifications: 'SCHEDULED_NOTIFICATIONS',
    postDepositAlertChecks: 'POST_DEPOSIT_ALERT_CHECKS',
    postClientSignUpActions: 'POST_CLIENT_SIGNUP_ACTIONS',
    createAlert: 'CREATE_ALERT',
    tradingEventProcessor: 'TRADING_EVENT_PROCESSOR',
    gdpr: 'GDPR',
    kyc: 'KYC',
    kycBlaclistedClients: 'KYC_BLACKLISTED_CLIENTS',
    reactivatePostponedAlerts: 'REACTIVATE_POSTPONED_ALERTS',
    notifyMerchant: 'NOTIFY_MERCHANT',
    pushNotifications: 'PUSH_NOTIFICATIONS',
    affiliateCommissions: 'PROCESS_AFFILIATE_COMMISSIONS',
    copyTradingPerformanceFees: 'COPY_TRADING_PERFORMANCE_FEES',
    sendStatement: 'SEND_STATEMENT',
};
export const jobStatuses = generateKeys({
    queued: {
        value: 'queued',
        label: 'Queued',
    },
    running: {
        value: 'running',
        label: 'Running',
    },
    completed: {
        value: 'completed',
        label: 'Completed',
    },
    completedWithError: {
        value: 'completed_with_error',
        label: 'Completed With Error',
    },
    stopped: {
        value: 'stopped',
        label: 'Stopped',
    },
});
export const jobTypes = generateKeys({
    cuboidDormantFee: {
        value: 'cuboidDormantFee',
        label: 'Cuboid Dormant Fee',
        backgroundType: backgroundJobs.cuboidDormantFee,
    },
    forexDormantFee: {
        value: 'forexDormantFee',
        label: 'Forex Dormant Fee',
        backgroundType: backgroundJobs.forexDormantFee,
    },
    spotOptionDormantFee: {
        value: 'spotOptionDormantFee',
        label: 'SpotOption Dormant Fee',
        backgroundType: backgroundJobs.spotOptionDormantFee,
    },
    tradeSmarterDormantFee: {
        value: 'tradeSmarterDormantFee',
        label: 'TradeSmarter Dormant Fee',
        backgroundType: backgroundJobs.tradeSmarterDormantFee,
    },
    affiliateCommissions: {
        value: 'affiliateCommissions',
        label: 'Affiliate Commissions',
        backgroundType: backgroundJobs.affiliateCommissions,
    },
});
export const jobActions = generateKeys({
    apply: {
        value: 'apply',
        label: 'Apply',
    },
    revert: {
        value: 'revert',
        label: 'Revert',
    },
});
export const inactivityFeeTypes = generateKeys({
    dormant: {
        value: 'dormant',
        label: 'Dormant',
    },
    maintenance: {
        value: 'maintenance',
        label: 'Maintenance',
    },
});
